import { useState, useRef } from 'react'
import { uploadProfielfoto, signOut } from '../lib/supabase'

const APP_VERSIE = '1.8.0'

export default function ProfileTab({ member, onSignOut, onUpdate }) {
  const [uploading, setUploading] = useState(false)
  const [feedback, setFeedback] = useState('')
  const [toonAV, setToonAV] = useState(false)
  const [toonPP, setToonPP] = useState(false)
  const fileRef = useRef(null)

  const initials = member.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()

  async function handleFotoUpload(e) {
    const file = e.target.files?.[0]
    if (!file) return
    setUploading(true)
    setFeedback('')
    try {
      const url = await uploadProfielfoto(member.user_id, file)
      onUpdate({ ...member, avatar_url: url })
      setFeedback('Foto bijgewerkt.')
    } catch (err) {
      setFeedback('Fout bij uploaden: ' + err.message)
    } finally {
      setUploading(false)
    }
  }

  async function handleSignOut() {
    await signOut()
    onSignOut()
  }

  return (
    <div>
      <div className="card" style={{ textAlign: 'center', padding: '24px 16px' }}>
        <div style={{ position: 'relative', display: 'inline-block', marginBottom: 12 }}>
          {member.avatar_url ? (
            <img
              src={member.avatar_url}
              alt={member.name}
              style={{ width: 80, height: 80, borderRadius: '50%', objectFit: 'cover', border: '3px solid var(--green)' }}
            />
          ) : (
            <div className="avatar" style={{ width: 80, height: 80, fontSize: 28, margin: '0 auto' }}>
              {initials}
            </div>
          )}
          <button
            onClick={() => fileRef.current?.click()}
            style={{
              position: 'absolute', bottom: 0, right: 0,
              width: 26, height: 26, borderRadius: '50%',
              background: 'var(--orange)', border: '2px solid #fff',
              cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
              <polyline points="17 8 12 3 7 8"/>
              <line x1="12" y1="3" x2="12" y2="15"/>
            </svg>
          </button>
          <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFotoUpload} />
        </div>

        {uploading && <p style={{ fontSize: 12, color: 'var(--muted)' }}>Uploaden…</p>}
        {feedback && <p style={{ fontSize: 12, color: feedback.includes('Fout') ? 'var(--red)' : 'var(--green-dark)' }}>{feedback}</p>}

        <p style={{ fontFamily: 'Montserrat', fontWeight: 800, fontSize: 18, color: 'var(--text)', marginTop: 8 }}>
          {member.name}
        </p>
        <p style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>Customer ID: {member.member_id}</p>
      </div>

      <div className="card" style={{ textAlign: 'center' }}>
        <p style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)', marginBottom: 8 }}>
          Tevreden over Vitaal Sterk?
        </p>
        <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 12 }}>
          Laat een Google review achter en help anderen ons te vinden.
        </p>
        
        <a
          href="https://www.google.com/maps/place/Vitaal+Sterk+Baarn/@52.2115247,5.2864748,17z/data=!4m8!3m7!1s0x47c641546a5a3f57:0xe3d63912c732287e!8m2!3d52.2115214!4d5.2890497!9m1!1b1!16s%2Fg%2F11t7mt90k8?entry=ttu&g_ep=EgoyMDI2MDYwMS4wIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            background: 'var(--green)',
            color: '#fff',
            borderRadius: 20,
            padding: '10px 24px',
            fontSize: 13,
            fontWeight: 700,
            fontFamily: 'Montserrat',
            textDecoration: 'none',
          }}
        >
          ⭐ Schrijf een review
        </a>
      </div>

      <div className="card">
        {[
          { label: 'Abonnement', value: member.plan },
          { label: 'Status', value: member.status === 'actief' ? '✓ Actief' : 'Inactief' },
        ].map(({ label, value }) => (
          <div key={label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
            <span style={{ fontSize: 13, color: 'var(--muted)' }}>{label}</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)' }}>{value}</span>
          </div>
        ))}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0' }}>
          <span style={{ fontSize: 13, color: 'var(--muted)' }}>Locatie</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)' }}>Baarn</span>
        </div>
      </div>

      <div className="card">
        <p style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--muted)', fontFamily: 'Montserrat', marginBottom: 12 }}>
          Openingstijden
        </p>
        {[
          { dag: 'Maandag',    tijd: '07:00 - 21:00' },
          { dag: 'Dinsdag',    tijd: '08:00 - 12:00 / 16:00 - 20:30' },
          { dag: 'Woensdag',   tijd: '07:00 - 12:00 / 16:00 - 21:00' },
          { dag: 'Donderdag',  tijd: '08:00 - 12:00 / 16:00 - 20:30' },
          { dag: 'Vrijdag',    tijd: '07:00 - 18:00' },
          { dag: 'Zaterdag',   tijd: '08:00 - 12:00' },
          { dag: 'Zondag',     tijd: '09:00 - 13:00' },
        ].map(({ dag, tijd }, i, arr) => (
          <div key={dag} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '9px 0', borderBottom: i < arr.length - 1 ? '1px solid var(--border)' : 'none' }}>
            <span style={{ fontSize: 13, color: 'var(--muted)', fontWeight: 500 }}>{dag}</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)', textAlign: 'right' }}>{tijd}</span>
          </div>
        ))}
      </div>

      <div className="card" style={{ background: 'var(--bg)', border: 'none' }}>
        <p style={{ fontSize: 11, color: 'var(--muted)', textAlign: 'center', marginBottom: 10 }}>
          Laanstraat 41c · 3743 BA Baarn · 035 303 7102
        </p>
      </div>


      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {[
          { label: 'Algemene voorwaarden', toon: toonAV, setToon: setToonAV, tekst: `Gefeliciteerd met de eerste stap naar een gezonde levensstijl en bedankt dat jij ons hiervoor hebt gekozen! Door jouw inschrijving verklaar je deze algemene voorwaarden en de huisregels van Vitaal Sterk BV te accepteren en hiernaar te handelen.

ARTIKEL 1: DEFINITIES
Ingangsdatum: dit is de aangegeven startdatum op het contract.

Garantieperiode: De eerste 3 maanden van het abonnement is de garantieperiode waarin er exact 20 keer dient te worden getraind met minimaal één rustdag tussen de trainingen. In dat geval behoudt het lid het recht om het abonnement binnen dezelfde periode te beëindigen. De overige looptijd van de overeenkomst komt te vervallen en er zijn geen verdere betalingsverplichtingen. De garantieperiode start vanaf de eerste training en verloopt exact 3 maanden na de eerste trainingsdag. Wanneer er na 20 trainingen wordt doorgegaan naar een nieuw trainingsplan/fase gaat automatisch de resterende looptijd van het contract in.

ARTIKEL 2: LID WORDEN EN TOEGANG
Eenieder is welkom om lid te worden bij Vitaal Sterk. Er kan worden gekozen uit de volgende abonnementen 12, 18 of 24 maanden. Daarnaast wordt er een bedrag voor inschrijf/administratie- en opstartkosten gehanteerd. Onder de inschrijfkosten vallen de volgende diensten: het aanleggen van het e-dossier, instellen van de apparatuur (Milon personal trainingssessie), gebruik van de clubgebonden applicaties. Er geldt een bedenktijd van één week na ondertekening van het contract. Het lid heeft de mogelijkheid om het contract kosteloos te herroepen, mits er nog geen gebruik is gemaakt van de diensten en faciliteiten. Indien hier wel gebruik van gemaakt is, zullen de inschrijf/administratie- en opstartkosten worden berekend. Voor de duur van het contract ontvangt het lid een pas of polsband waar gebruik van kan worden gemaakt tijdens het contract. Het lidmaatschap staat op naam en is niet overdraagbaar. Het lid is verantwoordelijk en aansprakelijk voor de wijze van gebruik en misbruik van de Vitaal Sterk pas/polsband en het lidmaatschap.

ARTIKEL 3: BEVRIEZINGEN
Voor iedere bevriezing dient er een bevriezingsformulier te worden getekend. Vitaal Sterk BV biedt haar leden de volgende mogelijkheden tot bevriezen:

Vakantie: per kalenderjaar is het mogelijk je abonnement voor in totaal maximaal 4 weken, met een minimum van 1 week per bevriezing, stil te leggen in verband met vakantie. Tijdens de vakantie loopt de betalingsverplichting door. Aan het einde van de abonnementsduur wordt de afwezige periode toegekend als gratis periode. Het kalenderjaar loopt van 01-01 t/m 31-12.

Blessure kort: de eerste 2 weken zijn voor eigen risico van de sporter, de 2 volgende weken kunnen desgewenst worden bevroren. Gedurende de afwezige periode loopt de betalingsverplichting door. Zodra het sporten weer wordt hervat, zal de afwezige periode worden verrekend met het maandelijkse abonnementsgeld.

Blessure lang: bij afwezigheid langer dan een maand door ziekte, ziekenhuisopname of sterftegeval van partner, is er de mogelijkheid om het abonnement tot 3 maanden te bevriezen. Gedurende deze periode worden de betalingsverplichtingen opgeschort, echter wordt de abonnementsduur verlengd met de bevroren periode.

Om gebruik te maken van blessure lang dient er een medisch attest of verklaring van overlijden te worden aangeleverd bij Vitaal Sterk BV. Hierna kan deze bevriezing pas in werking worden gesteld. Vitaal Sterk BV behoudt het recht om de aangevraagde bevriezing af te wijzen zolang er niet is voldaan aan de bovengenoemde voorwaarden. De bevroren periode wordt automatisch aan het eind van de looptijd van het abonnement toegevoegd.

ARTIKEL 4: BETALING
Als lid van Vitaal Sterk BV is er lidmaatschapsgeld verschuldigd vanaf het moment van inschrijving. De SEPA automatische incassomachtiging wordt vanaf dit moment in werking gesteld. Alle lidmaatschapsbedragen zijn bij vooruitbetaling verschuldigd en opeisbaar. Wanneer het lid in gebreke is gesteld of niet aan de betalingsverplichting voldoet zal Vitaal Sterk BV een tweede poging ondernemen om de contributie te incasseren. Indien het wederom niet voldaan kan worden, zal het openstaande achterstallige abonnementsgeld in één keer worden opgeëist via een incassobureau. De hiervoor bijkomende kosten zullen verhaald worden op het lid.

Indien het lid niet meer in bezit is van een pas of polsband, kan er een nieuwe pas of polsband worden aangeschaft op de ingeschreven vestiging. De oude pas of polsband wordt automatisch geblokkeerd. De vervangingsbijdrage voor een nieuwe pas of polsband bedraagt € 10,-. Deze vergoeding zit eenmalig in de inschrijfkosten. De volgende keren is het lid zelf verantwoordelijk voor de vervangingsbijdrage. Deze wordt bij de volgende incasso verrekend. In de tussentijd blijven de betalingsverplichtingen van kracht.

Vitaal Sterk BV behoudt zich het recht voor jaarlijks aanpassing te doen aan de hoogte van de contributie als de prijsontwikkelingen/inflatie daar aanleiding toe geven.

ARTIKEL 5: OPZEGGING
Het abonnement wordt aangegaan voor de op de overeenkomst vermelde vaste looptijd van 12, 18 of 24 maanden. Het lid kan het abonnement gedurende de vaste looptijd alvast opzeggen, waarbij het abonnement eindigt op de overeengekomen einddatum van de vaste looptijd. De opzegging dient uiterlijk één maand vóór deze einddatum te zijn ontvangen.

Na afloop van de vaste looptijd wordt het abonnement automatisch voortgezet voor onbepaalde tijd. Vanaf dat moment kan het lid het abonnement op ieder moment opzeggen met een opzegtermijn van één maand. De opzegtermijn gaat in per de eerste dag van de volgende kalendermaand. Voorbeeld: bij een opzegging op 15 mei eindigt het abonnement uiterlijk op 01 juli.

Opzegging kan persoonlijk plaatsvinden bij de vestiging van Vitaal Sterk door middel van het daarvoor bestemde opzegformulier.

Artikel 5.1: opzegging ter wille van een verhuizing is mogelijk indien het lid >5 km van de vestiging gaat wonen. Hiervoor dient een bewijs van inschrijving aangeleverd te worden.

Artikel 5.2: opzegging ter wille van een blessure, waardoor het sporten niet meer mogelijk is, kan alleen met een medische verklaring in behandeling genomen worden.

ARTIKEL 6: RISICO EN AANSPRAKELIJKHEID
Vitaal Sterk BV (en haar medewerkers) zijn niet aansprakelijk voor enig letsel of ongeval of zoekgeraakte voorwerpen van welke aard en door welke oorzaak dan ook. Voor het opbergen van eventuele waardevolle spullen kan er gebruik gemaakt worden van de aanwezige lockers.

ARTIKEL 7: GEDRAGSCODE
Leden die zich naar het oordeel van Vitaal Sterk's directie en/of haar personeelsleden schuldig maken aan wangedrag en/of (on)gewenste intimiteiten, kunnen tijdelijk of definitief de toegang worden ontzegd. Zij verliezen hun rechten doch behouden zij hun lopende verplichtingen.

ARTIKEL 8: KLEDINGVOORSCHRIFTEN
Wanneer er gebruik wordt gemaakt van de Vitaal Sterk BV faciliteiten dient er aan de kledingvoorschriften worden voldaan. Er dient omgekleed te worden in de aangewezen kleedruimtes. Gepaste sportkledij, schone sportschoenen en een handdoek zijn verplicht. Bij gebrek aan een handdoek biedt Vitaal Sterk BV haar leden de mogelijkheid om een handdoek in bruikleen te nemen. Leden dienen altijd schone binnen sportschoenen en gepaste sportkleding te dragen.

ARTIKEL 9: KLACHTEN
Vitaal Sterk BV doet haar uiterste best om haar leden van dienst te zijn en alle leden te motiveren tot een lange en gezonde leefstijl. Indien er klachten zijn betreurt Vitaal Sterk BV dit ten zeerste. Mocht een lid een klacht ervaren dan kan het lid zich in eerste instantie wenden tot één van de medewerkers in de vestiging. Indien dit niet leidt tot een gepaste oplossing kan er een mail gericht worden aan baarn@vitaal-sterk.nl.

ARTIKEL 10: PERSOONSGEGEVENS
Bij het ondertekenen van een Vitaal Sterk BV overeenkomst wordt er akkoord gegaan met de Algemene Verordening Gegevensbescherming (AVG). Eventuele foto- en video-opnames kunnen worden gebruikt voor promotionele doeleinden. Wanneer dit niet gewenst wordt door een lid, dient dit aangegeven te worden en zal Vitaal Sterk BV deze wens honoreren. Het lid dient wijzigingen in het post-, e-mailadres, bankrekening- en telefoonnummer tijdig schriftelijk mede te delen bij Vitaal Sterk BV. Contractant/cliënt verklaart over een goede gezondheid te bezitten en heeft geen lichamelijke belemmeringen voor het sportprogramma.

ARTIKEL 11: CAMERATOEZICHT
Vitaal Sterk BV maakt gebruik van video- en audiotoezichtapparatuur. Dit om de veiligheid te waarborgen van haar (personeels)leden en goederen. Video- en audiotoezicht is beperkt tot de sportruimte en koffiecorner en is daarmee niet aanwezig in het toilet en kleedruimtes. De opgenomen beelden worden voor een duur van twee weken bewaard en enkel teruggekeken bij ongevallen. Schade die door leden, bewust of onbewust wordt toegebracht aan inventaris en/of het pand zelf zal verhaald worden op de veroorzaker.

ARTIKEL 12: TOEPASSELIJK RECHT EN GESCHILLEN
Alle geschillen die ontstaan naar aanleiding van de overeenkomst tussen het lid en Vitaal Sterk BV zullen worden beoordeeld door de bevoegde rechter in het arrondissement waar de club gevestigd is. Vitaal Sterk BV behoudt ten alle tijden het recht om de algemene voorwaarden te wijzigen. Bij wijzigingen worden alle leden per mail op de hoogte gesteld.

ARTIKEL 13: GEGEVENSVERWERKING TRAININGSAPPARATUUR
Contractant/cliënt is ermee akkoord dat voor een optimale training en begeleiding op de toestellen, gegevens verwerkt worden in de software behorende bij de toestellen en er periodiek analyses gemaakt worden van de voortgang van training en bezoekgedrag. Deze gegevens zijn alleen voor intern gebruik en zijn bedoeld voor aanvullend advies voor een optimale begeleiding. Verstrekte gegevens zullen niet voor andere doeleinden worden gebruikt.

ARTIKEL 14: OPENINGSTIJDEN EN CONTACTGEGEVENS
Vitaal Sterk BV zal de openingstijden hanteren zoals vermeld in publicaties binnen de club en op onze website. Wijzigingen hierin en uitzonderingen tijdens bv. vakantieperiodes zullen ruim vooraf worden gepubliceerd.

September 2026` },
          { label: 'Privacybeleid', toon: toonPP, setToon: setToonPP, tekst: `Laatst gewijzigd: augustus 2026

Vitaal Sterk BV respecteert de privacy van haar leden en gaat zorgvuldig om met persoonsgegevens. Wij verwerken persoonsgegevens in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG).

In deze privacyverklaring leggen wij uit welke persoonsgegevens wij verwerken, waarvoor wij deze gebruiken en welke rechten u heeft.

1. Wie is verantwoordelijk voor uw persoonsgegevens?
Vitaal Sterk BV is verantwoordelijk voor de verwerking van uw persoonsgegevens.
Vitaal Sterk BV, Laanstraat 41c, 3743 BA Baarn. KvK: 86608843. E-mail: baarn@vitaal-sterk.nl

2. Welke persoonsgegevens verwerken wij?
Afhankelijk van uw relatie met Vitaal Sterk kunnen wij de volgende persoonsgegevens verwerken:
- Naam
- Geslacht
- Adresgegevens
- E-mailadres
- Telefoonnummer
- Bankrekeningnummer
- Geboortedatum en leeftijd
- Customer ID of klantnummer
- Gegevens over uw lidmaatschap
- Bezoekgegevens en voortgang van uw fasekaart

Wij verwerken alleen persoonsgegevens die noodzakelijk zijn voor onze dienstverlening en onze administratie.

Via de Vitaal Sterk ledenapp worden uitsluitend de gegevens verwerkt die nodig zijn voor het functioneren van de app. Dit betreft met name uw naam, customer ID en e-mailadres. Daarnaast wordt in de app uw voortgang op de fasekaart bijgehouden, waaronder uw bezoeken aan Vitaal Sterk. Via de ledenapp worden geen medische gegevens, gewicht of andere gezondheidsgegevens opgeslagen.

3. Waarvoor gebruiken wij uw persoonsgegevens?
Wij gebruiken uw persoonsgegevens voor:
- Het uitvoeren en beheren van uw lidmaatschap
- Onze ledenadministratie
- Het verwerken van betalingen
- Het registreren van bezoeken
- Het bijhouden van uw fasekaart
- Het informeren van leden over Vitaal Sterk
- Het versturen van nieuwsberichten en mededelingen
- Het beantwoorden van vragen
- Het onderhouden van contact met leden
- Het verzenden van aanbiedingen en andere commerciële communicatie
- Het verbeteren en beveiligen van onze dienstverlening
- Het voldoen aan wettelijke verplichtingen

4. De Vitaal Sterk ledenapp
Vitaal Sterk heeft een eigen ledenapp ontwikkeld. De app is bedoeld om leden op een eenvoudige manier te informeren en contact met Vitaal Sterk mogelijk te maken. Via de app kunnen onder andere: nieuwsberichten en mededelingen worden weergegeven; berichten rechtstreeks aan individuele leden worden gestuurd; berichten aan alle leden worden gestuurd; de persoonlijke fasekaart en bezoeken worden bijgehouden.

Voor het gebruik van de app worden alleen de persoonsgegevens verwerkt die daarvoor noodzakelijk zijn. Dit zijn de naam, customer ID en het e-mailadres van het lid. Voor de fasekaart wordt daarnaast bijgehouden welke bezoeken aan Vitaal Sterk zijn geregistreerd.

De gegevens die voor de ledenapp worden gebruikt, worden opgeslagen in een Europese databaseomgeving van Supabase. Vitaal Sterk heeft de ledenapp zelf ontwikkeld en bepaalt welke gegevens in de app worden verwerkt en waarvoor deze worden gebruikt.

5. Op welke grondslag verwerken wij uw gegevens?
Vitaal Sterk verwerkt persoonsgegevens wanneer daarvoor een wettelijke grondslag bestaat. Dit kan bijvoorbeeld zijn omdat de verwerking noodzakelijk is voor de uitvoering van uw lidmaatschap, omdat wij wettelijk verplicht zijn bepaalde gegevens te verwerken of omdat wij een gerechtvaardigd belang hebben. Voor zover voor een bepaalde verwerking toestemming nodig is, vragen wij daarvoor toestemming.

6. Commerciële communicatie
Vitaal Sterk kan leden informeren over onze dienstverlening, activiteiten en aanbiedingen. U kunt zich altijd afmelden voor commerciële nieuwsbrieven of aanbiedingen. U kunt hiervoor gebruikmaken van de afmeldmogelijkheid in het betreffende bericht of contact opnemen via baarn@vitaal-sterk.nl. U kunt ook bezwaar maken tegen het gebruik van uw persoonsgegevens voor direct marketing. Het afmelden voor commerciële communicatie heeft uiteraard geen gevolgen voor uw lidmaatschap.

7. Met wie delen wij uw gegevens?
Vitaal Sterk verkoopt uw persoonsgegevens niet aan derden. Wij delen persoonsgegevens alleen wanneer dit noodzakelijk is voor onze dienstverlening, wanneer wij daarvoor een wettelijke grondslag hebben of wanneer wij daartoe wettelijk verplicht zijn.

Voor de ledenapp maken wij gebruik van Supabase voor de opslag van de gegevens. De gegevens voor de ledenapp worden opgeslagen in een Europese regio. Daarnaast kunnen wij gebruikmaken van andere dienstverleners die namens Vitaal Sterk persoonsgegevens verwerken, bijvoorbeeld voor onze administratie, betalingen of IT-diensten. Waar nodig maken wij met dergelijke partijen afspraken over de bescherming van persoonsgegevens.

8. Hoe beschermen wij uw gegevens?
Vitaal Sterk neemt passende technische en organisatorische maatregelen om persoonsgegevens te beschermen tegen verlies, onbevoegde toegang en ongeoorloofd gebruik. Toegang tot persoonsgegevens wordt zoveel mogelijk beperkt tot personen en systemen die deze gegevens nodig hebben voor hun werkzaamheden.

9. Hoe lang bewaren wij uw gegevens?
Wij bewaren persoonsgegevens gedurende de looptijd van uw lidmaatschap en tot maximaal 2 jaar na beëindiging van uw lidmaatschap, tenzij een wettelijke verplichting een langere bewaartermijn voorschrijft. Gegevens waarvoor een wettelijke bewaarplicht geldt, zoals bepaalde gegevens uit onze financiële administratie, worden gedurende de wettelijk voorgeschreven termijn bewaard. Wanneer persoonsgegevens niet langer noodzakelijk zijn en er geen wettelijke verplichting bestaat om deze te bewaren, worden deze verwijderd of geanonimiseerd.

10. Uw rechten
U heeft op grond van de AVG verschillende rechten met betrekking tot uw persoonsgegevens. U kunt onder andere: uw persoonsgegevens opvragen; onjuiste gegevens laten aanpassen; verzoeken om gegevens te verwijderen; verzoeken om de verwerking van gegevens te beperken; bezwaar maken tegen bepaalde verwerkingen; bezwaar maken tegen het gebruik van uw gegevens voor direct marketing; wanneer van toepassing, uw gegevens laten overdragen. Wanneer u toestemming heeft gegeven voor een bepaalde verwerking, kunt u deze toestemming ook weer intrekken.

11. Een verzoek indienen
U kunt een verzoek of vraag over uw persoonsgegevens sturen naar: baarn@vitaal-sterk.nl. Wij reageren zo snel mogelijk en in ieder geval binnen de wettelijke termijn van één maand. Om uw persoonsgegevens te beschermen, kunnen wij bij een verzoek controleren of het verzoek daadwerkelijk door u is ingediend. Wij vragen daarbij alleen om aanvullende informatie wanneer dat redelijkerwijs noodzakelijk is om uw identiteit vast te stellen. Wij vragen niet standaard om een kopie van uw identiteitsbewijs. Wanneer een kopie van een identiteitsbewijs in een uitzonderlijk geval toch noodzakelijk is voor identificatie, kunt u gegevens die voor de identificatie niet nodig zijn afschermen.

12. Klachten
Heeft u een klacht over de manier waarop Vitaal Sterk met uw persoonsgegevens omgaat, neem dan eerst contact met ons op via baarn@vitaal-sterk.nl. U heeft daarnaast het recht om een klacht in te dienen bij de Autoriteit Persoonsgegevens.

13. Wijzigingen
Vitaal Sterk kan deze privacyverklaring wijzigen wanneer onze dienstverlening, de ledenapp of de toepasselijke wetgeving verandert. De meest actuele versie van deze privacyverklaring is beschikbaar via de communicatiekanalen van Vitaal Sterk.

14. Contact
Heeft u vragen over deze privacyverklaring of over de verwerking van uw persoonsgegevens? Neem dan contact met ons op:
Vitaal Sterk BV, Laanstraat 41c, 3743 BA Baarn. KvK: 86608843. E-mail: baarn@vitaal-sterk.nl

Deze privacyverklaring is voor het laatst gewijzigd in augustus 2026.` },
        ].map(({ label, toon, setToon, tekst }, i, arr) => (
          <div key={label} style={{ borderBottom: i < arr.length - 1 ? '1px solid var(--border)' : 'none' }}>
            <button
              onClick={() => setToon(!toon)}
              style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', background: 'none', border: 'none', cursor: 'pointer' }}
            >
              <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)' }}>{label}</span>
              <span style={{ fontSize: 16, color: 'var(--muted)', transform: toon ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}>›</span>
            </button>
            {toon && (
              <div style={{ padding: '0 16px 16px', fontSize: 12, color: 'var(--muted)', lineHeight: 1.7, whiteSpace: 'pre-line' }}>
                {tekst}
              </div>
            )}
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', padding: '8px 0 4px' }}>
        <p style={{ fontSize: 11, color: 'var(--muted)' }}>App-versie {APP_VERSIE}</p>
      </div>

      <button
        onClick={handleSignOut}
        className="btn-ghost"
        style={{ marginTop: 4, color: 'var(--red)', borderColor: 'var(--red)' }}
      >
        Uitloggen
      </button>
    </div>
  )
}
